type TConfig = {
  common: string[];
  feature: string;
};

export const translationConfig: TConfig = {
  common: [''],
  feature: 'Feature.Recommendations'
};

export default translationConfig;
